import { NavLink } from "react-router-dom";
import axios from "axios";
import logo from "../assets/logo-previ-mossoro.svg";
import { useKeycloak } from "../providers/keycloak-provider";

const baseNavItems = [
  { to: "/pontos",       label: "Ponto" },
  { to: "/funcionarios", label: "Funcionários" },
  { to: "/feriados",     label: "Feriados" },
  { to: "/dispositivo",  label: "Dispositivo" },
];

export default function Navbar() {
  const { keycloak } = useKeycloak();
  const tokenParsed = keycloak.tokenParsed as any;
  const displayName = tokenParsed?.name || tokenParsed?.preferred_username || tokenParsed?.email || "";
  const clientId    = import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? "";
  const realmRoles  = (tokenParsed?.realm_access?.roles ?? []) as string[];
  const clientRoles = (tokenParsed?.resource_access?.[clientId]?.roles ?? []) as string[];
  const allRoles    = [...realmRoles, ...clientRoles];
  const isAdmin     = allRoles.includes("admin");

  const navItems = isAdmin
    ? [...baseNavItems, { to: "/usuarios", label: "Usuários" }]
    : baseNavItems;

  return (
    <header className="bg-blue-700 shadow-md">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Brand */}
        <div className="flex items-center gap-3">
          <div className="mr-">
            <img src={logo} alt="Logo Previ Mossoró" className="w-20 h-9 " />
          </div>
          <NavLink to="/dashboard" className="flex items-center gap-2">
            <div>
              <p className="text-white font-bold text-base leading-none tracking-wide text-shadow-sm" style={{ fontSize: "14px" }}>
                Gestão de Ponto - Previ
              </p>
              <p className="text-blue-200 mt-0.5" style={{ fontSize: "12px" }}>
                Sistema de Gestão de Ponto Eletrônico
              </p>
            </div>
          </NavLink>
        </div>

        {/* Right actions */}
        <div className="flex items-center gap-3">
          <nav className="flex items-center gap-1 mr-2 text-sm hidden sm:flex">
            {navItems.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `text-sm px-3 py-1.5 rounded-lg transition-colors ${
                    isActive
                      ? "bg-white text-blue-700 font-semibold"
                      : "text-white hover:bg-white hover:text-blue-400 hover:bg-opacity-30"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <span className="text-[11px] text-blue-200 hidden sm:inline">{displayName}</span>
            <button
              type="button"
              onClick={() => {
                try {
                  delete axios.defaults.headers.common["Authorization"];
                  localStorage.clear();
                  sessionStorage.clear();
                  document.cookie.split(";").forEach(function(c) {
                    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
                  });
                  if (keycloak.authenticated) {
                    keycloak.logout({ redirectUri: window.location.origin })
                      .catch(() => { window.location.href = window.location.origin; });
                  } else {
                    window.location.href = window.location.origin;
                  }
                } catch {
                  window.location.href = window.location.origin;
                }
              }}
              className="text-sm text-blue-200 hover:text-white transition-colors bg-transparent border-0 cursor-pointer"
            >
              Sair
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
